export const CONTROL_HEIGHT = 44;
export const TEXTILE_PRODUCT_TYPE = "clothing_textile";
export const FIBRE_COMPOSITION_STEP_ID = "fibre-composition";

export const BASE_STEPS = [
  {
    id: "files",
    label: "Files",
    description:
      "Upload brand logo, product photo and declaration of conformity.",
  },
  {
    id: "traceability",
    label: "Product traceability",
    description: "Capture product identification and origin details.",
  },
  {
    id: "manufacturer",
    label: "Manufacturer & Representative",
    description:
      "Confirm manufacturer details and Authorized Representative.",
  },
  {
    id: FIBRE_COMPOSITION_STEP_ID,
    label: "Fibre composition",
    description: "Describe fibre components and percentages.",
  },
  {
    id: "safety",
    label: "Safety information",
    description:
      "Add product safety warnings, use restrictions and care instructions.",
  },
  {
    id: "preview",
    label: "GPSR Label & Digital Link",
    description:
      "Review your completed label, print it, or copy the digital link.",
  },
];

export const DECLARATION_ACCEPT = ".pdf,application/pdf";

export {
  FALLBACK_WEIGHT_UNIT_OPTIONS as GROSS_WEIGHT_UNIT_OPTIONS,
  FALLBACK_PRODUCT_CATEGORY_OPTIONS as PRODUCT_TYPE_OPTIONS,
} from "./gpsrSelectOptions";

export const DEFAULT_GROSS_WEIGHT_UNIT = "g";
